import {StartScreenView} from '@fantasmagames/slot/src/modules/startscreen/StartScreenView';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {SpineAnimationMultiTrack} from '@fantasmagames/core/src/display/SpineAnimationMultiTrack';
import {SpriteGraphics} from '@fantasmagames/core/src/display/SpriteGraphics';
import {Spine} from '@fantasmagames/core/src/spine/Spine';

export class GameStartScreenView extends StartScreenView {

	protected setupIntro(): void {
		this._introScreen = new Spine(this.resources.getSpine('STARTSCREEN.json', this.viewType));
		this._introFeatures = new Spine(this.resources.getSpine('FEATURE_SCREENS.json', this.viewType));
		this._extraBackground = SpriteGraphics.makeHiddenRectangle(
			this.resolutionManager.resolution.width,
			this.resolutionManager.resolution.height,
		);

		if (this.shouldReplaceLogoElement()) {
			const textureName: string = this.getTextureName();
			this.spineUtils.replaceElementInSpine(
				this._introFeatures,
				'FEATURE_1_LOGOTYPE',
				new PIXI.Sprite(this.resources.getTexture(`${textureName}_STARTSCREEN.png`)),
			);
		}

		const introPosition: Position = this.layout.getCenterOfScreen(this.viewType);
		this._introFeatures.position.set(introPosition.x, introPosition.y);

		this._screenAnimations = new SpineAnimationMultiTrack(this._introScreen);
		this._featuresAnimations = new SpineAnimationMultiTrack(this._introFeatures);
		this._screenAnimations.start();
		this._featuresAnimations.start();

		this.setupTranslatedWinUpTo();
	}

	protected shouldReplaceLogoElement(): boolean {
		return this.resources.getLocale().toLowerCase().indexOf('zh') > -1;
	}

	protected getTextureName(): string {
		switch (this.resources.getLocale().toLowerCase()) {
			case 'zh-cn':
				return 'LOGO_ZH_CN';
			case 'zh-tw':
				return 'LOGO_ZH_TW';

			default:
				return '';
		}
	}
}


// WEBPACK FOOTER //
// ./src/startscreen/GameStartScreenView.ts